import React, { useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import { LoadingSpinner } from '../../Loaders/Spinners/LoadingSpinner';
import type { SpinnerColorMode } from '../../Loaders/Spinners/types';
import { BUTTON__CONTENT_CLASS, SPINNER_CLASSNAME_PREFIX } from '../constants';
import type { ButtonTextColorMode } from '../types';
import { buttonContentTextColor } from '../styles/base.styles';
import { SPINNER_ANIMATION_DURATION_IN_MS } from '../styles/spinner.styles';
import * as styles from './ButtonInnerWithLoadingState.styles';

const textColorModeToSpinnerColorModeMapping: Record<ButtonTextColorMode, SpinnerColorMode> = {
  light: 'dark',
  dark: 'light',
  brand: 'light',
};

export interface ButtonInnerWithLoadingStateProps {
  children: React.ReactNode;
  compact?: boolean;
  loading: boolean;
  textColorMode: ButtonTextColorMode;
}

export const ButtonInnerWithLoadingState = ({
  children,
  compact,
  loading,
  textColorMode,
}: ButtonInnerWithLoadingStateProps) => {
  const [isSpinnerAnimating, setIsSpinnerAnimating] = useState(false);
  const spinnerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={BUTTON__CONTENT_CLASS} css={buttonContentTextColor[textColorMode]}>
      {!loading && !isSpinnerAnimating && children}
      <CSSTransition
        classNames={SPINNER_CLASSNAME_PREFIX}
        in={loading}
        nodeRef={spinnerRef}
        onEnter={() => setIsSpinnerAnimating(true)}
        onExited={() => setIsSpinnerAnimating(false)}
        timeout={SPINNER_ANIMATION_DURATION_IN_MS}
        unmountOnExit
      >
        <LoadingSpinner
          colorMode={textColorModeToSpinnerColorModeMapping[textColorMode]}
          css={compact ? undefined : styles.loadingSpinner}
          ref={spinnerRef}
          size={compact ? 'small' : 'medium'}
        />
      </CSSTransition>
    </div>
  );
};
